import { connect } from 'react-redux'
import { selectIsRightSidebarCollapsed } from 'selectors/app'
import { selectPrefersShowTopNav } from 'selectors/app/selectAccountPreferences'
import View from './view'

const select = state => {
  return {
    isRightSidebarCollapsed: selectIsRightSidebarCollapsed(state),
    showTopNav: selectPrefersShowTopNav(state),
  }
}

export default connect(select)(View)
